import { createContext, useContext, useEffect, useState } from 'react';
import { DEFAULT_STRAP_DESIGN, strapDesign, type StrapDesignKey } from '@airpost/shared';
import { boxCss, strapTexts } from './strap-art.js';

/**
 * A lower third previewed on the page in the station's design (ADR 083): the design's picture over a 16:9 box, the
 * strap's lines, today's date and the clock now in the design's boxes. The design is the one of the bulletin the
 * page is about (the story editor's, the story view's) or the edit's (the video editor), given by the context.
 */
export const StrapDesignContext = createContext<StrapDesignKey>(DEFAULT_STRAP_DESIGN);

/** The time now, again every 30 s while `on` (a design's date and clock). */
function useNow(on: boolean): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!on) return;
    const h = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(h);
  }, [on]);
  return now;
}

/** One lower third in the design of the context; a strap with no words yet shows "…". */
export function StrapArtView({ lines, className = '' }: { lines: readonly string[]; className?: string }) {
  const d = strapDesign(useContext(StrapDesignContext));
  const now = useNow(!!(d.date || d.clock));
  const shown = lines.some((l) => l.trim()) ? lines : ['…'];
  return (
    <div className={`cg-preview lt-art ${d.key} ${className}`} aria-hidden="true">
      <img src={d.src} alt="" draggable={false} />
      {strapTexts(d, shown, { now, clock: true }).map((x, i) => (
        <span key={i} className="lt-text" style={boxCss(x.box)}>
          <b>{x.text}</b>
        </span>
      ))}
    </div>
  );
}
